import ImgEC6 from '@/assets/svg/carmodel/ec6.png'
import ImgES6 from '@/assets/svg/carmodel/es6.png'
import ImgES7 from '@/assets/svg/carmodel/es7.png'
import ImgES8 from '@/assets/svg/carmodel/es8.png'
import ImgET5 from '@/assets/svg/carmodel/et5.png'
import ImgET7 from '@/assets/svg/carmodel/et7.png'

export const modelImgNames = {
	EC6: ImgEC6,
	ES6: ImgES6,
	ES8: ImgES8,
	ES7: ImgES7,
	ET5: ImgET5,
	ET7: ImgET7
}
export const modelImagePics = {
	// ET7: 'https://static.nio.com/fx-static/second-hand-mall-app/fixed/ET7.png',
	ET7: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/h8VNCsgEJLj4jGP3O56Hy/ET7.png',
	// ET5: 'https://static.nio.com/fx-static/second-hand-mall-app/fixed/ET5.png',
	ET5: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/j5OlukMy5N5VBCkG7vKIi/ET5.png',
	// ES8: 'https://static.nio.com/fx-static/second-hand-mall-app/fixed/ES8.png',
	ES8: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/l5Fk7aMmC2LdPNTYXmVxB/ES8.png',
	// ES7: 'https://static.nio.com/fx-static/second-hand-mall-app/fixed/ES7.png',
	ES7: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/B5ONlKJyeVp_r4ysqJYmq/ES7.png',
	// ES6: 'https://static.nio.com/fx-static/second-hand-mall-app/fixed/ES6.png',
	ES6: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/evm2TM60-g5XEz0k0Hi_F/ES6.png',
	// EC6: 'https://static.nio.com/fx-static/second-hand-mall-app/fixed/EC6.png',
	EC6: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/ZFL9GJ13RcZk6Gcj7xqmj/EC6.png',
	ET5T: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/XHsZCp14GEGZ-3sbyyRRQ/ET5T.png',
	EC7: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/tsrv5dTYPco8c0QMTTvtV/EC7.png',
	ET9: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/__cdn__/0JhjntfYGgqoufLukMRMG/ET9.png'
}

export const allCarTypes = ['ET7', 'ET5', 'ES8', 'ES7', 'ES6', 'EC6', 'ET5T', 'EC7', 'ET9']

export const allSeller = [
	{ value: 1, label: '官方二手车' },
	{ value: 2, label: '车主直售' }
]

export const allSortWays = [
	{ value: 'default', label: '综合排序' },
	{
		value: 'latest',
		label: '最新上架',
		order_column: 'shelf_status_time',
		order_asc: 'desc'
	},
	{
		value: 'increase',
		label: '价格由低到高',
		order_column: 'price',
		order_asc: 'asc'
	},
	{
		value: 'decrease',
		label: '价格由高到低',
		order_column: 'price',
		order_asc: 'desc'
	},
	{
		value: 'age',
		label: '车龄由新到旧',
		order_column: 'age',
		order_asc: 'asc'
	},
	{
		value: 'mileage',
		label: '里程由少到多',
		order_column: 'mileage',
		order_asc: 'asc'
	}
]

export const allCarColors = [
	{
		value: '白色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/es6013/app/f00002/7/basic.png?update_time=1685598728',
		includes: [{ label: '云白', value: 'pearl_white' }]
	},

	{
		value: '黑色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/es6013/app/f00002/6/basic.png?update_time=1685598728',
		includes: [{ label: '深空黑', value: 'deep_black' }]
	},

	{
		value: '银灰色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/es6013/app/f00002/9/basic.png?update_time=1685598728',
		includes: [
			{ label: '星灰', value: 'tech_grey' },
			{ label: '黎空银', value: 'sunrise_beige' }
		]
	},

	{
		value: '红色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/es6010/app/f00002/597/basic.png?update_time=1678963447',
		includes: [
			{ label: '火星红', value: 'mars_red' },
			{ label: '晨曦红', value: 'vivid_red' }
		]
	},

	{
		value: '蓝色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/es6013/app/f00002/726/basic.png?update_time=1685598728',
		includes: [
			{ label: '南极星蓝', value: 'southern_star_blue' },
			{ label: '同温层蓝', value: 'californiyeah_blue' },
			{ label: '天蓝', value: 'sky_blue' },
			{ label: '极空蓝', value: 'extreme_blue' },
			{ label: '星空蓝', value: 'star_blue' },
			{ label: '宇航蓝', value: 'airspace_bule' }
		]
	},

	{
		value: '绿色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/es6013/app/f00002/702/basic.png?update_time=1685598728',
		includes: [
			{ label: '极光绿', value: 'arctic_green' },
			{ label: '星辰绿', value: 'nebula_green' },
			{ label: '晨雾绿', value: 'misty_green' }
		]
	},

	{
		value: '橙色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/es6013/app/f00002/703/basic.png?update_time=1685598728',
		includes: [
			{ label: '霞光橙', value: 'luminous_orange' },
			{ label: '极光棕', value: 'urban_brown' }
		]
	},

	{
		value: '粉色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/et5001/app/f00002/725/basic.png?update_time=1686277020',
		includes: [{ label: '镜空粉', value: 'firstlight_kiss' }]
	},

	{
		value: '黄色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/et5001/app/f00002/724/basic.png?update_time=1686277020',
		includes: [{ label: '云初黄', value: 'sunbath_yellow' }]
	},

	{
		value: '金色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/et5001/app/f00002/70/basic.png?update_time=1686277020',
		includes: [{ label: '曙光金', value: 'sunlight_gold' }]
	},

	{
		value: '紫色',
		hex:
			'https://cdn-hydrus.nio.com/decepticons/es6013/app/f00002/780/basic.png?update_time=1685598728',
		includes: [
			{ label: '银河紫', value: 'galaxy_shadow' },
			{ label: '灵境紫', value: 'ar_lavender' },
			{
				label: '星云紫',
				value: 'energetic_violet'
			}
		]
	}
]

export const allColorPaints = allCarColors.reduce((prev, cur) => {
	return prev.concat(cur.includes)
}, [])

export function getPaintName(car) {
	const colorCode = car.car_paint

	if (!allColorPaints.some(one => one.value === colorCode)) {
		return ''
	}

	const label = allColorPaints.find(one => one.value === colorCode).label
	if (typeof label === 'string') {
		return label
	}

	return label(car)
}

export function getCarFullTitle(car) {
	return `${car.commodity_name} ${getPaintName(car)}`
}

export const allWheelMap = {
	alloy_19inch_5spoke: '19英寸五辐合金轮毂',
	alloy_20inch_multi_spoke: '20英寸多辐合金轮毂',
	alloy_20inch_machined: '20英寸抛光合金轮毂',
	alloy_21inch_sporty: '21英寸运动合金轮毂',
	alloy_21inch_carbon: '21英寸碳纤维合金轮毂',
	alloy_20inch_7spoke: '20英寸7幅合金轮毂',
	elegant_20inch_multi_spoke: '20英寸多辐星银轮毂',
	long_range_20inch_5spoke: '20英寸五辐长续航轮毂',
	performance_20inch_5spoke: '20英寸五辐䦀动轮毂',
	new_carbon_fiber_21inch: '21英寸碳纤维插片轮毂',
	aero_19inch_spoke: '19英寸低风阻云帆轮毂',
	elegant_19inch_silver_spoke: '19英寸多辐银辉轮毂',
	kappa_20inch_perform_spoke: '20英寸五辐锐钢轮毂',
	alpha_20inch_perform_spoke: '20英寸五辐花竞轮毂',
	elegant_20inch_dara_spoke: '20英寸多辐哑光合金轮毂',
	elegant_20inch_liufeng_spoke: '20英寸多辐哑光合金轮毂',
	aero_20inch_spoke: '20英寸低风阻炫黑轮毂',
	perform_21inch_spoke: '21英寸高性能竞帆轮毂',
	carbon_21inch_spoke: '21英寸碳纤维锐银轮毂'
}

export function getWheelName(wheel) {
	return allWheelMap[wheel] || ''
}

export function getVehicleQueryParams(filterConfig) {
	const params = {}

	if (filterConfig.carTypes.length) {
		params.model = filterConfig.carTypes.join(',')
	}

	if (filterConfig.sellers.length) {
		// MVP TODO business_type 参数拼接
		params.business_type = filterConfig.sellers.join(',')
	}

	if (filterConfig.originCities.length) {
		params.location_city_code = filterConfig.originCities.map(one => one.code).join(',')
	}
	if (filterConfig.priceRanges.length) {
		const range = filterConfig.priceRanges[0]

		if (typeof range[0] === 'number') {
			params.price_from = range[0] * 10000
		}

		if (typeof range[1] === 'number') {
			params.price_to = range[1] * 10000
		}
	}

	if (filterConfig.ages.length) {
		const range = filterConfig.ages[0]

		if (typeof range[0] === 'number') {
			params.age_from = range[0] * 12
		}

		if (typeof range[1] === 'number') {
			params.age_to = range[1] * 12
		}
	}
	if (filterConfig.mileages.length) {
		const range = filterConfig.mileages[0]

		if (typeof range[0] === 'number') {
			params.mileage_from = range[0] * 10000
		}

		if (typeof range[1] === 'number') {
			params.mileage_to = range[1] * 10000
		}
	}

	if (filterConfig.baasTypes.length === 1) {
		params.is_baas = filterConfig.baasTypes[0]
	}

	// 电池新增了类型，需要重新兼容
	if (filterConfig.battery && filterConfig.battery.length) {
		params.battery = [];
		// 全选的话，就不传了,非全选，传特定的值
		if (filterConfig.battery.length < 3) {
			filterConfig.battery.forEach(item => {
				params.battery.push(...item.split(','))
			})
		}
	}

	if (filterConfig.colors.length) {
		const codes = []
		filterConfig.colors.forEach(colorName => {
			const option = allCarColors.find(one => one.value === colorName)
			codes.push(option.includes.map(one => one.value))
		})
		params.car_paint = codes.join(',')
	}

	if (filterConfig.sort && filterConfig.sort !== 'default') {
		const way = allSortWays.find(one => one.value === filterConfig.sort)

		params.order_column = way.order_column
		params.order_asc = way.order_asc
	}

	return params
}

export function getTrackInfo(filterConfig) {
	const params = {
		car_model: '',
		transaction_type: '',
		vehicle_resource: '',
		price_range: ['0', '不限'],
		vehicle_age_range: ['0', '不限'],
		mileage_range: ['0', '不限'],
		battery_capacity: '',
		battery_plan: ''
	}

	if (filterConfig.carTypes.length) {
		params.car_model = filterConfig.carTypes.join(',')
	}

	if (filterConfig.sellers.length === 1) {
		params.transaction_type = filterConfig.sellers[0] === 1 ? '官方二手车' : '车主直售'
	}

	if (filterConfig.originCities.length) {
		params.vehicle_resource = filterConfig.originCities.map(one => one.name).join(',')
	}

	let price_range = []
	if (filterConfig.priceRanges.length) {
		const range = filterConfig.priceRanges[0]

		if (typeof range[0] === 'number') {
			price_range[0] = range[0] * 10000 + ''
		} else {
			price_range[0] = '0'
		}

		if (typeof range[1] === 'number') {
			price_range[1] = range[1] * 10000 + ''
		} else {
			price_range[1] = '不限'
		}
	}
	params.price_range = price_range

	let vehicle_age_range = []
	if (filterConfig.ages.length) {
		const range = filterConfig.ages[0]

		if (typeof range[0] === 'number') {
			vehicle_age_range[0] = range[0] + ''
		} else {
			vehicle_age_range[0] = '0'
		}

		if (typeof range[1] === 'number') {
			vehicle_age_range[1] = range[1] + ''
		} else {
			vehicle_age_range[1] = '不限'
		}
	}
	params.vehicle_age_range = vehicle_age_range

	let mileage_range = []
	if (filterConfig.mileages.length) {
		const range = filterConfig.mileages[0]

		if (typeof range[0] === 'number') {
			mileage_range[0] = range[0] * 10000 + ''
		} else {
			mileage_range[0] = '0'
		}

		if (typeof range[1] === 'number') {
			mileage_range[1] = range[1] * 10000 + ''
		} else {
			mileage_range[1] = '不限'
		}
	}
	params.mileage_range = mileage_range

	if (filterConfig.baasTypes.length === 1) {
		params.battery_plan = filterConfig.baasTypes[0] === 1 ? '整车购买' : '电池租用'
	}

	if (filterConfig.battery.length === 1) {
		if (filterConfig.battery[0] === 1) {
			params.battery_capacity = '70/75kWh'
		} else {
			params.battery_capacity = '100kWh'
		}
	}

	// if (filterConfig.colors.length) {
	// 	const codes = []
	// 	filterConfig.colors.forEach(colorName => {
	// 		const option = allCarColors.find(one => one.value === colorName)
	//
	// 		codes.push(option.includes.map(one => one.value))
	// 	})
	// 	params.car_paint = codes.join(',')
	// }

	return params
}

export function getEmptyFilter() {
	return {
		sort: 'default',

		battery: [], //  电池
		sellers: [], // 交易类型
		priceRanges: [], //  价格区间
		ages: [], //  车龄
		originCities: [], //车源地
		mileages: [], //  里程
		carTypes: [], //  车型
		baas: null, //  baas信息
		baasTypes: [],
		colors: [] //  车漆颜色
	}
}

export const allCarStatus = [
	{ label: '已下架', value: 1 },

	{ label: '已预订', value: 3 },
	{ label: '已出售', value: 4 },
	{ label: '已停售', value: 5 }
]

export const allCarDisabledStatus = [
	{ label: '已下架', value: 1 },

	{ label: '已出售', value: 4 },
	{ label: '已停售', value: 5 }
]

export const allInteriorColors = {
	LA1: '科技黑内饰',
	LA2: '都市棕内饰',
	LA3: '极速灰内饰',
	LA4: '科技黑内饰',
	LA5: '极速灰内饰',
	LA6: '运动灰内饰',
	LA7: '运动灰内饰',
	LA8: '喜马拉雅棕内饰',
	LA9: '金沙米内饰',
	LAA: '雪绒白内饰',
	LAB: '阿尔卑斯灰内饰',
	LAC: '雪绒白内饰',
	LAD: '金沙米内饰',
	LAE: '雪绒白内饰',
	LCM: '运动灰内饰',
	LLB: '都市棕内饰',
	LOB: '科技黑内饰',
	LAF: '帕米尔棕内饰',
	LAG: '琥珀橙内饰',
	LAH: '苔原绿内饰',
	LAJ: '电驭紫内饰',
	LAK: '苔原绿内饰',
	LAL: '马德拉红内饰'
}
